import { Routes, Route, Link, Outlet } from 'react-router-dom';
import './AccountWrapper.css';
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { isBuyer, isSeller, getCurrentUser, isAuthed, isEventHost, isAdmin } from '../../services/auth.service';
import { FaComment, FaDot, FaCommentAlt, FaRegComment, FaUser, FaUsers, FaChartPie, FaRegEnvelope, FaUserCog, FaRegComments, FaLink, FaShapes, FaSearch, FaDotCircle, FaStar, FaMoneyCheck, FaRegStar, FaChartLine, FaSlidersH, FaVectorSquare, FaRegUser, FaTicketAlt, FaUserLock, FaDollarSign, FaQuestionCircle, FaUserCircle } from 'react-icons/fa';
import ProfileCard from '../dashboard/ProfileCard';
import { useEffect } from 'react';
import { getFeedUnreplyCount, getUserCompany, getMessageUnreadCount, hasUnreadMessages, adminCheck } from '../../utils/api';
import { refresh } from '../../services/auth.service';
import Support from '../../components/support/Support';
import useSubscriberStatus from '../../hooks/useSubscriberStatus';
import {
  User,
  Users,
  Search,
  MessageSquare,
  Calendar,
  Clock,
  CheckSquare,
  BarChart,
  Mail,
  Settings,
  HelpCircle,
  ExternalLink,
  Shapes,
  DollarSign,
  PanelRightDashed,
  House,
  BarChart2,
  Unlock,
  Lock,
  Gift
} from 'lucide-react';

function AccountWrapper({ view }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [unreplyCount, setUnreplyCount] = useState(0);
  const [userCompany, setUserCompany] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const [hasCompany, setHasCompany] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const [shortMenu, setShortMenu] = useState(false);
  const { subscriberStatus, subscriberLoading, subscriberData, subscriberError, refetch } = useSubscriberStatus();
  
  const currentUser = getCurrentUser();

  async function loadUserCompany() {
    let res = await getUserCompany();

    if (res.success) {
      setUserCompany(res.data);
    }

    else if (res.status === 403) {
      await refresh();
      let res = await getUserCompany();

      if (res.success) {
        setUserCompany(res.data);
      }
    }

    else {
      setHasCompany(false);
    }

    setLoaded(true);
  }

  async function loadUnreplyCount() {
    let res = await getFeedUnreplyCount();

    if (res.success) {
      setUnreplyCount(res.data);
    }

    else if (res.status === 403) {
      await refresh();
      let res = await getFeedUnreplyCount();

      if (res.success) {
        setUnreplyCount(res.data);
      }
    }
  }

  async function checkUnread() {
    let res = await hasUnreadMessages();

    if (res.success) {
      if (res.data) {
        setHasUnread(true);
      }

      else {
        setHasUnread(false);
      }
    }

    if (res.status === 403) {
      await refresh();

      let res = await hasUnreadMessages();

      if (res.success) {
        if (res.data) {
          setHasUnread(true);
        }

        else {
          setHasUnread(false);
        }
      }
    }
  }

  async function loadUnreadCount() {
    let res = await getMessageUnreadCount();

    if (res.success) {
      setUnreadCount(parseInt(res.data));
    }

    else if (res.status === 403) {
      await refresh();

      let res = await getMessageUnreadCount();

      if (res.success) {
        setUnreadCount(parseInt(res.data));
      }
    }
  }

  useEffect(() => {
    loadUnreplyCount();
    loadUserCompany();
    checkUnread();
    loadUnreadCount();
  }, []);

  return (
    <>
      <div className='accountwrapper flex min-h-screen bg-gray-50'>
        <div className="w-82 bg-white border-r border-gray-200" style={{borderRight: 'solid 1px #ddd'}}>
          <div style={{borderBottom: 'solid 1px #ddd'}}>
            <ProfileCard />
          </div>

          {(isBuyer() === true || isSeller() === true || isEventHost() == true) && (
            <>
              <nav className="mt-4 px-8 sticky top-[20px]">
                <div className="space-y-1 accountmenu">
                  <div className=''>

                    {isBuyer() && isSeller() == false && (
                      <>
                        <Link to='/dashboard/buyer' className={view === "buyerdashboard" ? "selected" : "" + " flex items-center px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-purple-50 dark:hover:bg-purple-900/20 hover:text-purple-600 dark:hover:text-purple-400 rounded-md"}>
                          <span className='accountwrapper__icon'>
                            <FaRegComments />
                          </span>{' '}

                          <span className='accountwrapper__menu-item-name'>Dashboard</span>
                        </Link>

                        <div className='accountwrapper__submenu'>
                          <div className='accountwrapper__submenu-item'>
                            <Link to='/dashboard/buyer'>
                              <span><FaUsers /></span>
                              <span className='accountwrapper__menu-item-name'>Manage Demos</span>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}

                    {isBuyer() && isSeller() == true && (
                      <>
                        <Link to='/dashboard/buyer'>
                          <PanelRightDashed className="h-5 w-5 mr-3 text-gray-500" />

                          <span className='accountwrapper__menu-item-name'>Buyer Dashboard</span>
                        </Link>

                        <div className='accountwrapper__submenu'>
                          <div className='accountwrapper__submenu-item'>
                            <Link to='/dashboard/buyer' className={view === "buyerdashboard" ? "selected" : ""}>
                              <Calendar className="h-5 w-5 mr-3 text-gray-500" />
                              <span className='accountwrapper__menu-item-name'>Manage Demos</span>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}

                    {isSeller() && (
                      <>
                        <div>
                          <Link to='/dashboard/seller'>
                            <PanelRightDashed className="h-5 w-5 mr-3 text-gray-500" />
                            <span className='accountwrapper__menu-item-name'>Seller Dashboard</span>
                          </Link>

                          <div className='accountwrapper__submenu'>
                            <div className='accountwrapper__submenu-item'>
                              <Link to='/dashboard/performance' className={view === "performance" ? "selected" : ""}>
                                <BarChart2 className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Performance</span>
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to='/dashboard/seller' className={view === "sellerdashboard" ? "selected" : ""}>
                                <Calendar className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Manage Demos</span>
                                {/* <Unlock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" /> */}
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to='/dashboard/offers' className={view === "offers" ? "selected" : ""}>
                                <Gift className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Manage Offers</span>
                                {/* <Unlock className="h-3 w-3 text-purple-500 ml-2 text-gray-500" /> */}
                              </Link>
                            </div>

                            {/* <div className='accountwrapper__submenu-item'>
                              <Link to='/dashboard/my-price-leads' className={view === "priceleads" ? "selected" : ""}>
                                <DollarSign className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Price Leads</span>
                              </Link>
                            </div> */}

                              {userCompany && userCompany.company_id == 13011 && (
                              <div className='accountwrapper__submenu-item'>
                                <Link to='/search/buyers' className={view === "prospect" ? "selected" : ""}>
                                  <Search className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Prospect Search</span>

                                </Link>
                              </div>
                              )}

{userCompany && userCompany.company_id != 13011 && (
                              <div className='accountwrapper__submenu-item'>
                                <Link to='/dashboard/search' className={view === "prospect" ? "selected" : ""}>
                                  <Search className="h-5 w-5 mr-3 text-gray-500" />
                                  <span className='accountwrapper__menu-item-name'>Prospect Search</span>

                                </Link>
                              </div>
                              )}

                            <div className='accountwrapper__submenu-item'>
                              <Link to={'/account/team'} className={view === "team" ? "selected" : ""}>
                                <Users className="h-5 w-5 mr-3 text-gray-500" />

                                <span className='accountwrapper__menu-item-name'>
                                  Team
                                </span>
                              </Link>
                            </div>

                            {/* {isSeller() && userCompany && loaded === true && (
                              <div className='accountwrapper__submenu-item'>

                              <Link to={'/feed/company/' + userCompany.company_id} className={view === "feed" ? "selected" : ""}>
                                <MessageSquare className="h-5 w-5 mr-3 text-gray-500" />

                                <span className='accountwrapper__menu-item-name'>
                                  Discussion
                                  {unreplyCount != '0' && (
                                    <>
                                      <span className='accountwrapper__feed-unreply-count'>{unreplyCount} New Posts</span>
                                    </>
                                  )}
                                </span>
                              </Link>
                              </div>
                            )} */}

                            <div className='accountwrapper__submenu-item'>
                              <Link to={'/account/qualifiers'} className={view === "qualifiers" ? "selected" : ""}>
                                <HelpCircle className="h-5 w-5 mr-3 text-gray-500" />
                                <span className='accountwrapper__menu-item-name'>Qualification Questions</span>
                              </Link>
                            </div>

                            <div className='accountwrapper__submenu-item'>
                              <Link to={'/account/icp'} className={view === "icp" ? "selected" : ""}>
                              <User className="h-5 w-5 mr-3 text-gray-500" />
                              <span className='accountwrapper__menu-item-name'>Ideal Customer Profile</span>
                              </Link>
                            </div>
                          </div>
                        </div>

                        {/* <Link to='/s/recommendations' className={view==="sellerrecommendations"?"selected":""}>
            <span className='accountwrapper__icon'><FaRegStar /></span>{' '}
            <span>Available Buyers</span>
          </Link> */}

                        {/* {userCompany && loaded === true && userCompany.enable_search && (
            <Link to='/search/buyers' className={view==="searchbuyers"?"selected":""}>
            <span className='accountwrapper__icon'><FaSearch /></span>{' '}
            <span>Search Buyers</span>
          </Link>
          )}

          {isAdmin() == true && (
            <Link to='/dashboard/my-price-leads' className={view==="searchbuyers"?"selected":""}>
            <span className='accountwrapper__icon'><FaDollarSign /></span>{' '}
            <span>Price Leads</span>
          </Link>
          )} */}
                      </>
                    )}

                    {isEventHost() == true && (
                      <>
                                                  <div className='accountwrapper__submenu-item'>

                        <Link to='/account/events' className={view === "eventdashboard" ? "selected" : ""}>
                          <PanelRightDashed className="h-5 w-5 mr-3 text-gray-500" />

                          <span className='accountwrapper__menu-item-name'>Event Dashboard</span>
                        </Link>
                        </div>
                      </>
                    )}

                    {isAuthed() == true && (isBuyer() == true || isSeller() == true) && (
                                                  <div className='accountwrapper__submenu-item'>

                      <Link to='/dashboard/inbox' className={view === "inbox" ? "selected" : ""}>
                            <Mail className="h-5 w-5 mr-3 text-gray-500" />

                        <span className='accountwrapper__menu-item-name'>
                          <span>Inbox</span>

                          {unreadCount > 0 && (
                            <span className='header__unread-badge ml-4'>
                              {unreadCount}
                            </span>
                          )}

                          {
                            unreadCount == 0 && (
                              <span className='header__unread-badge ml-4' style={{ backgroundColor: '#f2f2f2', color: '#aaa' }}>
                                0
                              </span>
                            )
                          }
                        </span>
                      </Link>
                        </div>
                    )}

                    {isSeller() && (
                        <div className='accountwrapper__submenu-item'>

                      <Link to='/account/addons' className={view === "addons" ? "selected" : ""}>
                        <Shapes className="h-5 w-5 mr-3 text-gray-500" />

                        <span className='accountwrapper__menu-item-name'>Add-ons</span>
                      </Link>
                        </div>
                    )}

<div className='accountwrapper__submenu-item'>
                    <Link to='/account/home' className={view === "settings" ? "selected" : ""}>
                    <Settings className="h-5 w-5 mr-3 text-gray-500" />

                      <span className='accountwrapper__menu-item-name'>
                        Settings
                      </span>
                    </Link>
                    </div>

                  </div>
                </div>

                { !subscriberLoading && subscriberData && subscriberData.length == 0 && (
                  <div className="mt-8 bottom-4">
                    <div className="rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 p-4 shadow-lg">
                      <h3 className="text-sm font-medium text-white">Upgrade Your Account</h3>
                      <p className="mt-1 text-sm text-purple-100">Get access to all premium features</p>
                      <Link
                        to="/subscription"
                        className="mt-3 flex w-full items-center justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white/20"
                      >
                        View Plans
                      </Link>
                    </div>
                  </div>
                )}
              </nav>
            </>
          )}
        </div>

        <div className='account__content'>
          <Outlet />
        </div>

        <Support />
      </div>
    </>
  );
}

export default AccountWrapper;
